// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSConfig.custom.products_per_page,
    // Optional
    loadProductFirst: true,
    numberFilterTree: 2,
    filterTreeMobileStyle: "style3",
    capitalizeFilterOptionValues: false,
    separateRefineByFromFilter: false,
  },
  selectors: {
    breadcrumb: "#breadcrumb", // Selector for breadcrumb
    trackingQuickView: '[data-fancybox="quick-view"]', // Defaut is '',
    trackingAddToCart: 'form[action="/cart/add"] *[type="submit"]', // Default is 'form[action="/cart/add"] *[type="submit"]',
    trackingBuyNow: ".shopify-payment-button, #dynamic-checkout-cart", // Default is '.shopify-payment-button, #dynamic-checkout-cart'
  },
};

(function () {
  BoostPFS.inject(this);
  var boostPFSImgDefaultSrc =
      "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
    boostPFSRangeWidths = [
      180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048,
    ];

  if (Utils.isMobile()) {
    boostPFSFilterConfig.general.separateRefineByFromFilter = true;
  }
  // Build Product List
  ProductGridItem.prototype.compileTemplate = function (
    data,
    index,
    totalProduct
  ) {
    if (!data) data = this.data; // Add this line
    if (!index) index = this.index; // Add this line
    if (!totalProduct) totalProduct = this.totalProduct; // Add this line
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale

    // Calculate special sale discount
    var specialSaleDisplay = "";
    var hasSpecialSale = false;
    var bestDiscountSavings = 0;
    var bestDiscountDisplay = "";

    // ORIGINAL PERCENT OFF LOGIC (restored)
    var percentOff = "";
    var percentOffCollectionHandle =
      boostPFSConfig.custom.percentage_off_collection;
    var percentageThreshold = boostPFSConfig.custom.percentage_off_threshold;
    var currentCollection = boostPFSConfig.custom.current_collection;
    if (onSale && boostPFSConfig.custom.show_percent_off) {
      let percentCalc =
        100 - (data.price_min * 100) / data.compare_at_price_min;
      if (
        percentCalc > percentageThreshold &&
        currentCollection === percentOffCollectionHandle
      ) {
        percentOff = `SAVE ${percentCalc.toString().split(".")[0]}%`;
      }
    }

    // NEW SPECIAL SALE LOGIC
    if (data.collections && data.collections.length > 0) {
      // Loop through all 5 special sales
      for (let i = 1; i <= 5; i++) {
        let specialSaleEnabled =
          boostPFSConfig.custom["enable_special_sale_" + i];
        let specialSaleCollections =
          boostPFSConfig.custom["special_sale_collection_" + i] || [];
        let specialSaleDiscountValue =
          boostPFSConfig.custom["special_sale_discount_value_" + i] || 0;
        let specialSaleDiscountType =
          boostPFSConfig.custom["special_sale_discount_type_" + i];

        if (
          specialSaleEnabled &&
          specialSaleCollections.length > 0 &&
          specialSaleDiscountValue > 0
        ) {
          // Check if product is in any of this sale's collections (optimized)
          let productCollectionIds = data.collections.map((c) => c.id);
          let productInSaleCollection = specialSaleCollections.some(
            (saleCollectionId) =>
              productCollectionIds.includes(saleCollectionId)
          );

          if (productInSaleCollection) {
            // Calculate actual savings for this discount
            let currentSavings = 0;
            let currentDisplay = "";

            if (specialSaleDiscountType === "percent") {
              currentSavings =
                (data.price_min * specialSaleDiscountValue) / 100;
              currentDisplay = specialSaleDiscountValue + "% OFF";
            } else {
              currentSavings = specialSaleDiscountValue * 100; // Convert to cents
              currentDisplay = "$" + specialSaleDiscountValue + " OFF";
            }

            // Check if this is the best discount so far
            let isBetterDiscount = false;
            if (currentSavings > bestDiscountSavings) {
              isBetterDiscount = true;
            } else if (
              currentSavings === bestDiscountSavings &&
              specialSaleDiscountType === "amount"
            ) {
              // When savings are equal, prefer dollar amount
              isBetterDiscount = true;
            }

            if (isBetterDiscount) {
              hasSpecialSale = true;
              bestDiscountSavings = currentSavings;
              bestDiscountDisplay = currentDisplay;
            }
          }
        }
      }
    }

    // PRIORITY: Special Sales take precedence over original percent off
    if (hasSpecialSale) {
      specialSaleDisplay = bestDiscountDisplay;
    } else if (percentOff) {
      specialSaleDisplay = percentOff;
    }
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    itemHtml = itemHtml.replace(
      /{{grid_item_width}}/g,
      boostPFSConfig.custom.grid_item_width
    );
    itemHtml = itemHtml.replace(
      /{{scroll_animation}}/g,
      boostPFSConfig.custom.scroll_animation
    );

    // Add Label
    var itemNewLabelHtml = "";
    var itemSaleLabelHtml = "";
    var itemSoldoutLabelHtml = "";
    if (!soldOut) {
      for (var k = 0; k < data.collections.length; k++) {
        if (data["collections"][k]["handle"] == "new") {
          itemNewLabelHtml = boostPFSTemplate.newLabelHtml;
          break;
        }
      }
      if (onSale) {
        itemSaleLabelHtml = boostPFSTemplate.saleLabelHtml;
      }
    } else {
      itemSoldoutLabelHtml = boostPFSTemplate.soldOutLabelHtml;
    }
    itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);
    itemHtml = itemHtml.replace(/{{itemSoldoutLabel}}/g, itemSoldoutLabelHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable
      ? boostPFSTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor)
      : "";
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add price
    var moneyPrice = priceVaries
      ? boostPFSConfig.label.from_lowest_price_html.replace(
          /{{ lowest_price }}/,
          Utils.formatMoney(data.price_min)
        )
      : Utils.formatMoney(data.price_min);
    var unit_measure = "";
    if (firstVariant && firstVariant.unit_price_measurement) {
      if (firstVariant.unit_price_measurement.reference_value !== 1) {
        unit_measure = firstVariant.unit_price_measurement.reference_value;
      } else {
        unit_measure = firstVariant.unit_price_measurement.reference_unit;
      }
    }
    var itemPriceHtml = '<div class="price price--listing';
    if (soldOut) {
      itemPriceHtml += " price--sold-out";
    }
    if (onSale) {
      itemPriceHtml += " price--on-sale";
    }
    if (!priceVaries && data && data.compare_at_price_varies) {
      itemPriceHtml += " price--compare-price-hidden";
    }
    if (
      data &&
      data.selected_or_first_available_variant &&
      typeof data.selected_or_first_available_variant.unit_price_measurement !==
        "undefined"
    ) {
      itemPriceHtml += " price--unit-available";
    }
    itemPriceHtml += '">';

    itemPriceHtml += `<dl class="price__regular"><dt>
		<span class="visually-hidden visually-hidden--inline">${
      boostPFSConfig.label.regular_price
    }</span>
		</dt><dd>
		<span class="price-item price-item--regular">${moneyPrice}</span>
		</dd></dl>
		<dl class="price__sale"><dt>
		<span class="visually-hidden visually-hidden--inline">${
      boostPFSConfig.label.regular_price
    }</span>
		</dt><dd>
		<s class="price-item price-item--regular">${Utils.formatMoney(
      data.compare_at_price_min
    )}</s>
		</dd><dt>
		<span class="visually-hidden visually-hidden--inline">${Utils.formatMoney(
      data.sale_price
    )}</span>
		</dt><dd>
		<span class="price-item price-item--sale">${moneyPrice}</span>		
		</dd></dl>
		<dl class="price__unit"><dt>
		<span class="visually-hidden visually-hidden--inline">${
      boostPFSConfig.label.unit_price
    }</span>
		</dt>
		<dd class="price-unit-price">
		<span>${boostPFSConfig.label.unit_price}</span>
		<span aria-hidden="true">/</span>
		<span class="visually-hidden">${
      boostPFSConfig.label.unit_price_separator
    }</span>
		<span>${unit_measure}</span>
		</dd></dl></div>`;

    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Images
    var itemImagesHtml = "";
    if (images.length > 0) {
      itemImagesHtml += buildImage(images[0], data);
      if (boostPFSConfig.custom.image_flip_enable && images.length > 1) {
        itemImagesHtml +=
          '<div class="hidden">' + buildImage(images[1], data) + "</div>";
      }
    } else {
      itemImagesHtml = buildImage(null);
    }
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add aspect ratio
    itemHtml = itemHtml.replace(
      /{{aspect_ratio}}/g,
      boostPFSConfig.custom.product_image_size
    );

    // Add Quick view
    var itemQuickViewHtml = boostPFSConfig.custom.quick_view_enable
      ? boostPFSTemplate.quickViewHtml
      : "";
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    // Add size swatch
    var itemSizeSwatchHtml = buildSizeSwatch(data);
    itemHtml = itemHtml.replace(/{{itemSizeSwatch}}/g, itemSizeSwatchHtml);

    // Add color swatch
    var itemColorSwatchHtml = buildColorSwatch(data);
    itemHtml = itemHtml.replace(/{{itemColorSwatch}}/g, itemColorSwatchHtml);

    // Add add to cart
    var itemAddToCartHtml = buildAddToCart(data, firstVariant);
    itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, itemAddToCartHtml);

    // Add Reviews
    if (
      typeof Integration === "undefined" ||
      !Integration.hascompileTemplate("reviews")
    ) {
      var itemReviews = "";

      if (
        boostPFSThemeConfig.custom.hasOwnProperty("show_rating") &&
        boostPFSThemeConfig.custom.show_rating == true &&
        Utils.getProductMetafield(data, "reviews", "rating") !== null
      ) {
        var ratingObj = JSON.parse(
          Utils.getProductMetafield(data, "reviews", "rating")
        );
        var rating_decimal = 0;
        var decimal = parseFloat(ratingObj.value.rating);
        if (decimal >= 0.3 && decimal <= 0.7) {
          rating_decimal = 0.5;
        } else if (decimal > 0.7) {
          rating_decimal = 1;
        }
        itemReviews += '<div class="product__section--rating-wrapper">';
        itemReviews +=
          '<div class="product__section-rating" role="img" aria-label="';
        itemReviews += boostPFSConfig.label.star_reviews_info
          .replace("{{ rating_value }}", ratingObj.value)
          .replace("{{ rating_max }}", ratingObj.value.scale_max);
        itemReviews += '">';
        itemReviews +=
          '<span aria-hidden="true" class="product__section-rating-star color-icon" style="';
        itemReviews +=
          "--rating: " +
          Math.round(ratingObj.value.rating) +
          "; --rating-max: " +
          ratingObj.value.scale_max +
          "; --rating-decimal: " +
          rating_decimal +
          ';"></span>';
        itemReviews += "</div>";
        itemReviews += '<p class="product__section-rating-text caption">';
        itemReviews +=
          '<span aria-hidden="true">' +
          ratingObj.value / ratingObj.value.scale_max +
          "</span>";
        itemReviews += "</p>";
        itemReviews += '<p class="product__section-rating-count caption">';
        itemReviews +=
          '<span aria-hidden="true">(' +
          Utils.getProductMetafield(data, "reviews", "rating_count") +
          ")</span>";
        itemReviews +=
          '<span class="visually-hidden">' +
          Utils.getProductMetafield(data, "reviews", "rating_count") +
          " " +
          boostPFSConfig.label.total_reviews +
          "</span>";
        itemReviews += "</p>";
        itemReviews += "</div>";
      }
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviews);
    }

    // Add main attribute
    titleWithoutStyleNumbers = data.title.substring(
      0,
      data.title.lastIndexOf("(")
    );
    // console.log(`Testing title substitution ${productTitle}`);
    itemHtml = itemHtml.replace(/{{itemPriceNumber}}/g, data.price_min);
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemOnSale}}/g, onSale);
    itemHtml = itemHtml.replace(/{{specialSaleDisplay}}/g, specialSaleDisplay);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, titleWithoutStyleNumbers);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrl(data)
    );

    return itemHtml;
  };

  function buildImage(image, data) {
    var rangeWidths = boostPFSRangeWidths;
    var dataSrcSet = "",
      dataWidths = "",
      dataSizes = "auto",
      imgAlt = image && image.alt ? image.alt : data.title;

    for (var i = 0; i < rangeWidths.length; i++) {
      dataSrcSet +=
        Utils.optimizeImage(
          image.src || boostPFSConfig.general.no_image_url,
          rangeWidths[i] + "x"
        ) +
        " " +
        rangeWidths[i] +
        "w";
      dataWidths += rangeWidths[i];

      if (i < rangeWidths.length - 1) {
        dataSrcSet += ", ";
        dataWidths += ", ";
      }
    }

    var html =
      '<div class="box-ratio" style="padding-bottom: {{imagePadding}};">' +
      '<img class="" ' +
      'id="{{imageId}}" ' +
      'src="{{imageUrl}}"' +
      // 							'data-src="{{imageUrl}}" ' +
      // 							'data-srcset="{{imageSrcSet}}" ' +
      // 							'data-width="{{imageWidth}}" ' +
      // 					        'data-sizes="{{imageSizes}}" ' +
      'alt="{{itemTitle}}"> ' +
      "</div>";
    html = html.replace(/{{placeholder}}/g, boostPFSImgDefaultSrc);
    html = html.replace(/{{itemTitle}}/g, imgAlt);
    html = html.replace(/{{imageWidth}}/g, "[" + dataWidths + "]");
    html = html.replace(/{{imageSizes}}/g, dataSizes);
    html = html.replace(/{{imageSrcSet}}/g, dataSrcSet);

    if (image && image.src) {
      var imagePadding = (image.height / image.width) * 100;
      html = html.replace(
        /{{imageUrl}}/g,
        Utils.optimizeImage(
          image.src || boostPFSConfig.general.no_image_url,
          rangeWidths[2] + "x"
        )
      );
      html = html.replace(/{{imageId}}/g, image.id);
      html = html.replace(/{{imagePadding}}/g, imagePadding + "%");
    } else {
      html = html
        .replace(/{{imagePadding}}/g, "100%")
        .replace(/{{imageId}}/g, "")
        .replace(/{{imageUrl}}/g, boostPFSConfig.general.no_image_url);
    }
    return html;
  }

  function buildSizeSwatch(data) {
    var html = "";
    var swatchItems = [];
    var sizeOptionIndex = 0;

    if (boostPFSConfig.custom.product_info == "sizes" && data.available) {
      var sizeKeys = ["size", "sizes"];
      var sizeValues = [];
      data.variants.forEach(function (variant) {
        var sizeValue = null;
        variant.merged_options.forEach(function (merged_option, optionIndex) {
          var key = merged_option.split(":")[0];
          var value = merged_option.split(":")[1];
          if (
            sizeKeys.indexOf(key.toLowerCase().trim()) != -1 &&
            sizeValues.indexOf(value.toLowerCase().trim()) == -1
          ) {
            sizeValue = value;
            sizeValues.push(value.toLowerCase().trim());
            sizeOptionIndex = optionIndex;
          }
        });
        if (variant.inventory_quantity > 0) {
          if (sizeValue) {
            var swatchItem =
              '<li data-option-title="{{sizeValue}}" data-href="{{variantImage}}" class="color {{sizeValue}}">' +
              '<a href="{{variantUrl}}">{{sizeValue}}</a>' +
              "</li>";

            var variantImage = variant.image
              ? variant.image
              : data.images_info.length > 0
              ? data.images_info[0].src
              : boostPFSAppConfig.general.no_image_url;
            swatchItem = swatchItem.replace(
              /{{variantImage}}/g,
              Utils.optimizeImage(variantImage, "large")
            );
            swatchItem = swatchItem.replace(/{{sizeValue}}/g, sizeValue);
            swatchItem = swatchItem.replace(
              /{{variantUrl}}/g,
              "{{itemUrl}}?variant=" + variant.id
            );
            swatchItems.push(swatchItem);
          }
        }
      });
      if (swatchItems.length > 0) {
        html =
          '<div class="size-swatch"><ul data-option-index="' +
          sizeOptionIndex +
          '" class="size options">' +
          swatchItems.join(" ") +
          "</ul></div>";
      }
    }
    return html;
  }

  function buildColorSwatch(data) {
    var html = "";
    var swatchItems = [];
    var colorOptionIndex = 0;
    if (boostPFSConfig.custom.product_info == "colors" && data.available) {
      var colorKeys = ["color", "colors", "colour", "colours"];
      var colorValues = [];
      data.variants.forEach(function (variant) {
        var colorValue = null;
        variant.merged_options.forEach(function (merged_option, optionIndex) {
          var key = merged_option.split(":")[0];
          var value = merged_option.split(":")[1];
          if (
            colorKeys.indexOf(key.toLowerCase().trim()) != -1 &&
            colorValues.indexOf(value.toLowerCase().trim()) == -1
          ) {
            colorValue = value;
            colorValues.push(value.toLowerCase().trim());
            colorOptionIndex = optionIndex;
          }
        });
        if (colorValue) {
          var swatchItem =
            '<li data-option-title="{{colorValue}}" data-href="{{variantImage}}" class="color {{colorValue}}">' +
            '<a href="{{variantUrl}}">' +
            (boostPFSConfig.custom.color_swatch_options == "variant-image" &&
            variant.image
              ? '<img class="variant-image" src="{{variantImage}}" alt="{{colorValue}}">'
              : '<span class="custom-image css-color" style="width: 25px; height: 25px; ' +
                'background-color: {{backgroundColor}}; background-image: url({{backgroundImage}});">' +
                "</span>") +
            "</a>";
          ("</li>");

          var variantImage = variant.image
            ? variant.image
            : data.images_info.length > 0
            ? data.images_info[0].src
            : boostPFSAppConfig.general.no_image_url;
          swatchItem = swatchItem.replace(
            /{{variantImage}}/g,
            Utils.optimizeImage(variantImage, "large")
          );
          swatchItem = swatchItem.replace(
            /{{variantUrl}}/g,
            "{{itemUrl}}?variant=" + variant.id
          );
          swatchItem = swatchItem.replace(/{{colorValue}}/g, colorValue);
          swatchItem = swatchItem.replace(
            /{{backgroundColor}}/g,
            Utils.slugify(colorValue).split("-").pop()
          );

          var backgroundImage =
            boostPFSAppConfig.general.file_url.split("?")[0] +
            Utils.slugify(colorValue) +
            ".png";
          swatchItem = swatchItem.replace(
            /{{backgroundImage}}/g,
            backgroundImage
          );
          swatchItems.push(swatchItem);
        }
      });
      if (swatchItems.length > 0) {
        html =
          '<div class="col-swatch"><ul data-option-index="' +
          colorOptionIndex +
          '" class="size options">' +
          swatchItems.join(" ") +
          "</ul></div>";
      }
    }
    return html;
  }

  function buildAddToCart(data, firstVariant) {
    var html = "";
    if (
      boostPFSConfig.custom.product_info == "add_to_cart" &&
      !boostPFSConfig.custom.quick_view_enable
    ) {
      html = '<div class="quick-add-to-cart">';
      if (
        data.variants &&
        data.variants.length <= 1 &&
        data.available &&
        firstVariant
      ) {
        html +=
          '<form action="/cart/add" method="post" data-money-format="' +
          boostPFSAppConfig.shop.money_format +
          '" data-product-id="{{itemId}}" enctype="multipart/form-data" class="product_form">' +
          '<div class="product-variants"></div>' +
          '<input  type="hidden" id="' +
          firstVariant.id +
          '" name="id" data-sku="' +
          firstVariant.sku +
          '" value="' +
          firstVariant.id +
          '" />' +
          '<div class="product-add">' +
          '<input type="submit" name="button" class="add clearfix AddtoCart" value="' +
          boostPFSConfig.label.add_to_cart +
          '" />' +
          "</div>" +
          "</form>";
      } else {
        html +=
          '<div class="product-add">' +
          '<a class="add options button clearfix" href="{{itemUrl}}">' +
          boostPFSConfig.label.select_options +
          "</a>" +
          "</div>";
      }
      html += "</div>";
    }
    return html;
  }

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build wrapper
      paginationHtml = paginationHtml.replace(
        /{{paginateWrapperClass}}/g,
        "twelve"
      );

      // Build Previous
      var previousHtml = currentPage > 1 ? '<a href="{{itemUrl}}"><</a>' : "";
      previousHtml = previousHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage - 1)
      );
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml =
        currentPage < totalPage ? '<a href="{{itemUrl}}">></a>' : "";
      nextHtml = nextHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage + 1)
      );
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (
        var iBefore = currentPage - 1;
        iBefore > currentPage - 3 && iBefore > 0;
        iBefore--
      ) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift("...");
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (
        var iAfter = currentPage + 1;
        iAfter < currentPage + 3 && iAfter <= totalPage;
        iAfter++
      ) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push("...");
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = "";
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == "...") {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml +=
            pageArr[iPage] == currentPage
              ? boostPFSTemplate.pageItemSelectedHtml
              : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(
          /{{itemUrl}}/g,
          Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
        );
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }

    return "";
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || "";
        // Build content
        var sortingItemsHtml =
          '<input class="chosen-value js-hz-filter-input" type="text" value="" data-placeholder="Sort by" placeholder="{{placeholder}}"><ul class="value-list js-hz-filter-list">';
        for (var k in sortingArr) {
          if (paramSort == k) {
            sortingItemsHtml = sortingItemsHtml.replace(
              /{{placeholder}}/g,
              `Sort by - ${sortingArr[k]}`
            );
          }
          if (sortingArr[k] != "Relevance" && sortingArr[k] != "Featured") {
            sortingItemsHtml += '<li class="available">';
            sortingItemsHtml +=
              '<input type="checkbox" name="sort_by"' + ' value="' + k + '">';
            sortingItemsHtml +=
              '<span class="js-hz-filter-label">' + sortingArr[k] + "</span>";
            sortingItemsHtml += "</li>";
          }
        }
        sortingItemsHtml += "</ul>";
        sortingItemsHtml = sortingItemsHtml.replace(/{{placeholder}}/g, "");
        var html = boostPFSTemplate.sortingHtml.replace(
          /{{sortingItems}}/g,
          sortingItemsHtml
        );
        return html;
      }
    }
  };

  ProductSorting.prototype.afterBindEvents = function () {
    jQ(".collection__filtering").on("click", function (e) {
      e.stopPropagation();
      jQ(".chosen-value").addClass("active");
      jQ(".value-list").addClass("open");
    });

    // 		jQ('.collection__filtering').on('focusout', function () {
    // 			jQ('.chosen-value').removeClass('active');
    // 			jQ('.value-list').removeClass('open');
    // 		});

    jQ(".value-list > li").on("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      jQ(".chosen-value").removeClass("active");
      jQ(".value-list").removeClass("open");
      FilterApi.setParam("sort", jQ(this).find("input").val());
      FilterApi.setParam("page", 1);
      FilterApi.applyFilter("sort");
    });
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;
    // Hide filter tree when no product except filtering
    if (
      (jQ(".boost-pfs-filter-message").length > 0 &&
        Globals.queryParams.event_type !== "filter") ||
      (jQ(".product-list-no-search-result-text").length > 0 &&
        Globals.queryParams.event_type === "init")
    ) {
      jQ(".boost-pfs-filter-left-col").hide();
      jQ(".boost-pfs-filter-right-col")
        .removeClass("span-9")
        .addClass("span-12");
    } else {
      jQ(".boost-pfs-filter-left-col").show();
      jQ(".boost-pfs-filter-right-col")
        .removeClass("span-12")
        .addClass("span-9");
    }
    if (jQ(".boost-pfs-product-no-search-result-title").length > 0) {
      jQ(".product-loop").addClass("no-result-custom");
    }

    // Hide empty special sale badges
    jQ(".special-sale-badge").each(function () {
      if (jQ(this).text().trim() === "") {
        jQ(this).hide();
      }
    });

    /* if (typeof Shopify !== 'undefined') {
          Shopify.theme.quickview.init();
        } */
  };

  // Capitalize label of filter option
  FilterResult.prototype.afterRender = function (data) {
    var data = this.data;

    var from =
      Globals.queryParams.page == 1
        ? Globals.queryParams.page
        : (Globals.queryParams.page - 1) * Globals.queryParams.limit + 1;
    var to = Globals.queryParams.page * Globals.queryParams.limit;
    jQ(Selector.bottomPagination)
      .find(".count")
      .html(
        boostPFSConfig.label.showing_items +
          " " +
          from +
          "-" +
          to +
          " / " +
          data.total_product
      );

    if (window.SPR) {
      SPR.initDomEls();
      SPR.loadBadges();
    }
  };

  Filter.prototype.afterRender = function (data) {
    if (!data) data = this.data;
  };

  FilterLoadingIcon.prototype.isEnabled = function () {
    return (
      Settings.getSettingValue("general.showLoading") ||
      Settings.getSettingValue("general.showMobileLoading")
    );
  };
})();

jQ("body").on("click", function () {
  jQ(".chosen-value").removeClass("active");
  jQ(".value-list").removeClass("open");
});
